import { AxiosInstance, AxiosResponse } from 'axios';
import { VersionsInfoResponse } from './responses/versions-info.response';

export class HealthModuleClient {
  constructor(private readonly client: AxiosInstance) {}

  async getVersions(tag: string): Promise<AxiosResponse<VersionsInfoResponse>> {
    return await this.client.get(`/health/versions/${tag}`);
  }
}
